'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcSlider = require('rc-slider');

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _SliderHandle = require('./SliderHandle');

var _SliderHandle2 = _interopRequireDefault(_SliderHandle);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Slider.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * A slider component with multi-range support
  */
var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
  }

  _createClass(Slider, [{
    key: 'getRange',
    value: function getRange() {
      var _props = this.props,
          min = _props.min,
          max = _props.max,
          step = _props.step;

      var range = [];

      for (var i = min; i <= max; i += step) {
        range.push(i);
      }

      return range;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(value) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;


      return _react2.default.createElement(
        'div',
        { className: 'mark' },
        _react2.default.createElement('div', { className: 'mark-line' }),
        _react2.default.createElement(
          'div',
          { className: 'mark-value' },
          (value === min || value === max) && _react2.default.createElement(
            'div',
            null,
            value
          )
        )
      );
    }
  }, {
    key: 'getMarks',
    value: function getMarks() {
      var _this2 = this;

      return this.getRange().reduce(function (acc, cur) {
        acc[cur] = {
          label: _this2.renderLabel(cur)
        };

        return acc;
      }, {});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var marks = this.props.displayMarks ? this.getMarks() : {};
      var dataHook = this.props.dataHook;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('wix-slider', { rtl: this.props.rtl }), id: this.props.id, 'data-hook': dataHook },
        _react2.default.createElement(_rcSlider.Range, {
          handle: function handle(props) {
            return _react2.default.createElement(_SliderHandle2.default, _extends({ key: props.index, displayTooltip: _this3.props.displayTooltip }, props));
          },
          min: this.props.min,
          max: this.props.max,
          value: this.props.value,
          marks: marks,
          step: this.props.step,
          pushable: this.props.pushable,
          onChange: this.props.onChange,
          onAfterChange: this.props.onAfterChange,
          allowCross: this.props.allowCross
        })
      );
    }
  }]);

  return Slider;
}(_react.Component);

exports.default = Slider;


Slider.displayName = 'Slider';

Slider.propTypes = {
  /** Allows the slider's handles to cross. */
  allowCross: _propTypes2.default.bool,
  dataHook: _propTypes2.default.string,

  /** Controls the visibility of the marks. */
  displayMarks: _propTypes2.default.bool,

  /** Controls visibility of slide handle tooltip */
  displayTooltip: _propTypes2.default.bool,
  id: _propTypes2.default.string,

  /** The absolute maximum of the slider's range */
  max: _propTypes2.default.number,

  /** The absolute minimum of the slider's range */
  min: _propTypes2.default.number,

  /** Called after every value change */
  onAfterChange: _propTypes2.default.func,

  /** Called upon every value change */
  onChange: _propTypes2.default.func.isRequired,

  /** Adjust for RTL dir. */
  rtl: _propTypes2.default.bool,

  /** The slider's step */
  step: _propTypes2.default.number,

  /** Allow pushing of surrounding handles when moving a handle. Number means a minimum distance between handles */
  pushable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),

  /** The slider's selected range */
  value: _propTypes2.default.arrayOf(_propTypes2.default.number)
};

Slider.defaultProps = {
  min: 1,
  max: 20,
  step: 1,
  value: [2, 7],
  allowCross: true,
  id: (0, _uniqueId2.default)(),
  displayTooltip: true,
  displayMarks: true,
  rtl: false
};